import { useEffect } from "react";

const BASE = "HERUS Axiom";

function setMeta(name, content, attr = "name") {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useSEO({ title, fullTitle, description, keywords, path }) {
  useEffect(() => {
    const computed = fullTitle
      ? fullTitle
      : title
      ? `${title} — ${BASE}`
      : `${BASE} — Structuration de projets & gouvernance`;
    document.title = computed;
    setMeta("description", description);
    setMeta("keywords", keywords);
    setMeta("og:title", computed, "property");
    setMeta("og:description", description, "property");
    setMeta("og:type", "website", "property");
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${window.location.origin}${path || window.location.pathname}`);
  }, [title, fullTitle, description, keywords, path]);
}
